import classNames from 'classnames';
import Card from 'components/Card';
import CardContent from 'components/CardContent';
import Typography from 'components/Typography';
import {get} from 'lodash';
import styles from './PaymentDetails.module.scss';
import StatusBadge from 'components/StatusBadge';
import {InfoIcon} from '../../icons';
import {Prescription} from 'types/request';
import {PackageIcon} from 'pages/DeliveryPlanner/components/OrderDetailsModal/icons';
import {WrenchIcon} from 'pages/Signup/icons';

function PaymentDetails({datas}: {datas: any}) {
  const items = get(datas, 'request_drugs', []);
  const service = get(datas, 'request_drugs', []).find(
    (item: any) => item.offering_type === 'service'
  );
  const products = get(datas, 'request_drugs', []).filter(
    (item: any) => item.offering_type === 'product'
  );
  const totalAmount = items?.reduce(
    (acc: number, item: Prescription) => acc + Number(item.amount_due),
    0
  );
  return (
    <Card className={styles.card}>
      <CardContent pt="sm" className={styles.cardContent}>
        <Typography className={styles.title} variant="h4">
          <InfoIcon className={styles.infoIcon} />
          Payment Details
        </Typography>

        <div className={styles.row}>
          <Typography className={classNames(styles.label)} variant="label">
            Customer
          </Typography>
          <Typography className={classNames(styles.text)} variant="p">
            {get(datas, 'request.customer')}
          </Typography>
        </div>

        <div className={styles.row}>
          <Typography className={classNames(styles.label)} variant="label">
            Order #
          </Typography>
          <Typography className={classNames(styles.text)} variant="p">
            {get(datas, 'request.sequential_order_number')}
          </Typography>
        </div>

        <div className={classNames(styles.row)}>
          <Typography className={classNames(styles.label)} variant="label">
            Status
          </Typography>

          <StatusBadge color="canceled">Unpaid</StatusBadge>
        </div>
        {service && (
          <>
            <Typography className={styles.productsTitle} variant="h4">
              <WrenchIcon width={18} height={18} color="#1A6AE5" />
              Service
            </Typography>
            <div className={styles.row}>
              <Typography className={classNames(styles.label)} variant="label">
                {service?.name}
              </Typography>
              <Typography className={classNames(styles.text)} variant="p">
                ${service?.amount_due}
              </Typography>
            </div>
          </>
        )}
        {products.length > 0 && (
          <Typography variant="h4" className={styles.productsTitle}>
            <PackageIcon width={18} height={18} color="#1A6AE5" />
            Products
          </Typography>
        )}
        {products?.map((item: any) => (
          <div className={styles.row} key={item.id}>
            <Typography className={classNames(styles.label)} variant="label">
              {item?.name}
            </Typography>
            <Typography className={classNames(styles.text)} variant="p">
              ${item.amount_due}
            </Typography>
          </div>
        ))}

        <div className={classNames(styles.row, styles.statusRow)}>
          <Typography className={classNames(styles.label)} variant="label">
            Total Amount
          </Typography>
          <Typography className={classNames(styles.text)} variant="p">
            ${totalAmount}
          </Typography>
        </div>
      </CardContent>
    </Card>
  );
}
export default PaymentDetails;
